import { useContext } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import BoardsAll from "./components/BoardsAll/BoardsAll";
import SideBar from "./components/SideBar/SideBar";
import ModalSwitchboard from "./components/ModalSwitchboard/ModalSwitchboard";
import ToastContainer from "./components/Toast/ToastContainer";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import { BoardProvider } from "./store/board-context";
import { ThemeProvider, ThemeContext } from "./store/theme-context";
import { AuthProvider, AuthContext } from "./store/auth-context";
import { ToastProvider } from "./store/toast-context";

const ThemedApp = () => {
  const { theme } = useContext(ThemeContext);

  return (
    <div className={`app ${theme}`}>
      <BoardProvider>
        <BoardsAll />
        <SideBar />
        <ModalSwitchboard />
      </BoardProvider>
    </div>
  );
};

const RequireAuth = ({ children }) => {
  const { user, isAuthLoading } = useContext(AuthContext);

  if (isAuthLoading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <ToastProvider>
      <AuthProvider>
        <ThemeProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route
                path="/*"
                element={
                  <RequireAuth>
                    <ThemedApp />
                  </RequireAuth>
                }
              />
            </Routes>
          </BrowserRouter>
          <ToastContainer />
        </ThemeProvider>
      </AuthProvider>
    </ToastProvider>
  );
}

export default App;
